import React from 'react'
import { Button } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import { ThumbsUp } from '@emotion-icons/feather'

const ThumbsUpIcon = chakra(ThumbsUp)

// TODO [FEATURE-671]: Have to be generalized to `ButtonWithState` + properly themed!
const defaultStyles = {
    backgroundColor: 'gray.bg_light',
    border: 'none',
    color: 'text.500',
    _focus: {
        boxShadow: `outline_gray_lg`,
        outline: 'none',
    },
    _focusVisible: {
        outline: 'none',
    },
    _hover: {
        color: 'text.500',
        backgroundColor: 'gray.dividers',
    },
}

const likedStyles = {
    backgroundColor: 'secondary.500',
    border: 'none',
    color: 'white',
    _focus: {
        boxShadow: `outline_secondary`,
        outline: 'none',
    },
    _focusVisible: {
        outline: 'none',
    },
    _hover: {
        backgroundColor: 'secondary.600',
    },
}

export const ButtonLike = ({
    likes = 1,
    isLiked = false,
    isDisabled = false,
    handleClick,
}: {
    likes: number
    isLiked: boolean
    isDisabled: boolean
    handleClick?: () => void
}) => {
    const styles = isLiked ? likedStyles : defaultStyles

    return (
        <Button
            {...styles}
            display={'flex'}
            gridGap={'8px'}
            fontWeight={'700'}
            onClick={handleClick}
            disabled={isDisabled}
        >
            <ThumbsUpIcon height={'24px'} width={'24px'} strokeWidth={'2px'} />
            <span>{likes}</span>
        </Button>
    )
}
